import { Icon, type FixedIconProps, type IconPaths } from './Icon';

import React from 'react';
import { Path } from 'react-native-svg';

export function Jobs(props: Readonly<FixedIconProps>): React.JSX.Element {
    const paths: IconPaths = {
        filled: (
            <>
                <Path d="M4 21C3.45 21 2.97917 20.8042 2.5875 20.4125C2.19583 20.0208 2 19.55 2 19V12H10C10 13.1046 10.8954 14 12 14C13.1046 14 14 13.1046 14 12H22V19C22 19.55 21.8042 20.0208 21.4125 20.4125C21.0208 20.8042 20.55 21 20 21H4Z" />
                <Path
                    d="M2 10V8C2 7.45 2.19583 6.97917 2.5875 6.5875C2.97917 6.19583 3.45 6 4 6H8V4C8 3.45 8.19583 2.97917 8.5875 2.5875C8.97917 2.19583 9.45 2 10 2H14C14.55 2 15.0208 2.19583 15.4125 2.5875C15.8042 2.97917 16 3.45 16 4V6H20C20.55 6 21.0208 6.19583 21.4125 6.5875C21.8042 6.97917 22 7.45 22 8V10H2ZM10 6H14V4H10V6Z"
                    fillRule="evenodd"
                    clipRule="evenodd"
                />
            </>
        ),
        filledrtl: (
            <>
                <Path d="M4 21C3.45 21 2.97917 20.8042 2.5875 20.4125C2.19583 20.0208 2 19.55 2 19V12H10C10 13.1046 10.8954 14 12 14C13.1046 14 14 13.1046 14 12H22V19C22 19.55 21.8042 20.0208 21.4125 20.4125C21.0208 20.8042 20.55 21 20 21H4Z" />
                <Path
                    d="M2 10V8C2 7.45 2.19583 6.97917 2.5875 6.5875C2.97917 6.19583 3.45 6 4 6H8V4C8 3.45 8.19583 2.97917 8.5875 2.5875C8.97917 2.19583 9.45 2 10 2H14C14.55 2 15.0208 2.19583 15.4125 2.5875C15.8042 2.97917 16 3.45 16 4V6H20C20.55 6 21.0208 6.19583 21.4125 6.5875C21.8042 6.97917 22 7.45 22 8V10H2ZM10 6H14V4H10V6Z"
                    fillRule="evenodd"
                    clipRule="evenodd"
                />
            </>
        ),
        stroke: (
            <Path
                d="M2.5875 20.4125C2.97917 20.8042 3.45 21 4 21H20C20.55 21 21.0208 20.8042 21.4125 20.4125C21.8042 20.0208 22 19.55 22 19V8C22 7.45 21.8042 6.97917 21.4125 6.5875C21.0208 6.19583 20.55 6 20 6H16V4C16 3.45 15.8042 2.97917 15.4125 2.5875C15.0208 2.19583 14.55 2 14 2H10C9.45 2 8.97917 2.19583 8.5875 2.5875C8.19583 2.97917 8 3.45 8 4V6H4C3.45 6 2.97917 6.19583 2.5875 6.5875C2.19583 6.97917 2 7.45 2 8V19C2 19.55 2.19583 20.0208 2.5875 20.4125ZM20 10V8H4V10H20ZM4 12V19H20V12H14C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12H4ZM14 6H10V4H14V6Z"
                fillRule="evenodd"
                clipRule="evenodd"
            />
        ),
        strokertl: (
            <Path
                d="M2.5875 20.4125C2.97917 20.8042 3.45 21 4 21H20C20.55 21 21.0208 20.8042 21.4125 20.4125C21.8042 20.0208 22 19.55 22 19V8C22 7.45 21.8042 6.97917 21.4125 6.5875C21.0208 6.19583 20.55 6 20 6H16V4C16 3.45 15.8042 2.97917 15.4125 2.5875C15.0208 2.19583 14.55 2 14 2H10C9.45 2 8.97917 2.19583 8.5875 2.5875C8.19583 2.97917 8 3.45 8 4V6H4C3.45 6 2.97917 6.19583 2.5875 6.5875C2.19583 6.97917 2 7.45 2 8V19C2 19.55 2.19583 20.0208 2.5875 20.4125ZM20 10V8H4V10H20ZM4 12V19H20V12H14C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12H4ZM14 6H10V4H14V6Z"
                fillRule="evenodd"
                clipRule="evenodd"
            />
        ),
    };

    return <Icon paths={paths} {...props} />;
}
